import { GoogleGenAI } from "@google/genai";
import { SYSTEM_INSTRUCTION } from '../constants';

// The API key must be obtained from process.env.API_KEY.
// We access it here, and the Vite build config ensures process.env is defined.
const apiKey = process.env.API_KEY;

let ai: GoogleGenAI | null = null;
if (apiKey) {
  ai = new GoogleGenAI({ apiKey: apiKey });
}

export const sendMessageToGemini = async (message: string, history: { role: string; text: string }[] = []): Promise<string> => {
  if (!ai) {
    return "I'm sorry, I am currently offline (API Key missing). Please contact us directly via the form.";
  }

  try {
    // Construct history for the model
    // The SDK expects 'user' and 'model' roles.
    const chatHistory = history.map(h => ({
      role: h.role,
      parts: [{ text: h.text }]
    }));

    const chat = ai.chats.create({
      model: 'gemini-2.5-flash',
      config: {
        systemInstruction: SYSTEM_INSTRUCTION,
      },
      history: chatHistory
    });

    const result = await chat.sendMessage({
      message: message
    });

    return result.text || "I'm sorry, I couldn't generate a response at this moment.";
  } catch (error) {
    console.error("Gemini API Error:", error);
    return "I apologize, but I'm having trouble connecting to my knowledge base right now. Please try again later.";
  }
};